module.exports = __webpack_public_path__ + "media/images/lb/094-385bbca73481f2b492e95d0f7db1c25b.svg";